import { render, staticRenderFns } from "./UserCash.vue?vue&type=template&id=be7ae4aa&scoped=true&"
import script from "./UserCash.vue?vue&type=script&lang=js&"
export * from "./UserCash.vue?vue&type=script&lang=js&"
import style0 from "./UserCash.vue?vue&type=style&index=0&id=be7ae4aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7ae4aa",
  null
  
)

export default component.exports